import { ProgressSteps as AntdProgressSteps } from "@empglabs/backoffice-ui-kit"

const ProgressSteps = props => {
  return <AntdProgressSteps {...props} />
}

export default ProgressSteps
